import { render, staticRenderFns } from "./Token.vue?vue&type=template&id=85edd27a&"
import script from "./Token.vue?vue&type=script&lang=js&"
export * from "./Token.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports